import { render, staticRenderFns } from "./PlanejamentoPrognose.vue?vue&type=template&id=694dae9a&scoped=true"
import script from "./PlanejamentoPrognose.vue?vue&type=script&lang=js"
export * from "./PlanejamentoPrognose.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoPrognose.vue?vue&type=style&index=0&id=694dae9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694dae9a",
  null
  
)

export default component.exports